export default __webpack_public_path__ + "media/zurb/img/services/tools/helio-screenshot2-58ffc4f627447699b7474477d4539584.png";